import styled from "styled-components";

export const Container = styled.div`
  align-items: center;
  display: flex;
  height: 10rem;
  justify-content: center;

  p.standalone-message__title {
    ${(props) => `
      color: ${props.theme.colors.gray};
      font-family: ${props.theme.fontFamilies.primaryFont};
    `}

    font-size: 1.8rem;
    font-weight: 500;
  }
`;
